import { useMemo } from 'react'

import { useCurrentUserLanguage } from '../../account/hooks/useCurrentUserLanguage'
import { TrackedGame } from '../types/TrackedGame'

type UseLiveEventBlueprintNameParams = {
  blueprintId: string | undefined
  trackedGame: TrackedGame | undefined
}

/**
 * Hook to fetch live event blueprint name by ID
 * @param blueprintId - The ID of the blueprint to fetch*
 * @param trackedGameId - The ID of the tracked game to fetch
 * @returns Object containing blueprint name, loading state, and error state
 */
export const useLiveEventBlueprintName = ({ blueprintId, trackedGame }: UseLiveEventBlueprintNameParams) => {
  const userLanguage = useCurrentUserLanguage()

  const blueprintName = useMemo(() => {
    if (!trackedGame?.blueprints || !blueprintId) {
      return undefined
    }

    // Try to get the name in the user's language, fallback to English, then any available language
    return (
      trackedGame.blueprints.find((blueprint) => blueprint.blueprintId === blueprintId)?.names[userLanguage] ||
      trackedGame.blueprints.find((blueprint) => blueprint.blueprintId === blueprintId)?.names['en'] ||
      undefined
    )
  }, [trackedGame, userLanguage, blueprintId])

  return blueprintName
}

export const useLiveEventBlueprintDiscontinued = ({ blueprintId, trackedGame }: UseLiveEventBlueprintNameParams) => {
  return trackedGame?.blueprints?.find((blueprint) => blueprint.blueprintId === blueprintId)?.discontinued
}
